import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { MembershipTypeStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import autobind from 'autobind-decorator';
import Grid from 'components/layout/grid';

@observer
class MembershipTypeEdit extends React.Component {

  componentDidMount() {
    MembershipTypeStore.getShow({ids: {membershipTypeId: this.props.params.membershipTypeId}}, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    MembershipTypeStore.setShowData(resp);
  }

  render() {
    return (
      <div className='membership-type-edit'>
        <Grid columns={3} gap='sm'>
          <InPlaceText
            legend='Name'
            id={MembershipTypeStore.showData.id}
            defaultValue={MembershipTypeStore.showData.name}
            field='name'
            model='membership_types'
          />
          <InPlaceText
            legend='Slug'
            id={MembershipTypeStore.showData.id}
            defaultValue={MembershipTypeStore.showData.slug}
            field='slug'
            model='membership_types'
          />
          <InPlaceCheckbox
            legend='Active'
            value={MembershipTypeStore.showDataField('active')}
            model='membership_types'
            field='active'
            id={MembershipTypeStore.showDataField('id')}
          />
        </Grid>
        <InPlaceText
          legend='Description (Markdown)'
          markdown
          id={MembershipTypeStore.showData.id}
          defaultValue={MembershipTypeStore.showData.descriptionMd}
          field='description_md'
          model='membership_types'
        />
        <InPlaceText
          legend='Description (HTML)'
          richText
          id={MembershipTypeStore.showData.id}
          defaultValue={MembershipTypeStore.showData.description}
          field='description'
          model='membership_types'
        />
      </div>
    );
  }
}

export default ErrorBoundary(MembershipTypeEdit);
